import { bedActions } from './constants';

const INITIAL_STATE = {
  sickbed: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case bedActions.SET_SICKBED:
      return { ...state, sickbed: action.payload };
    default:
      return state;
  }
}
